import React, { useEffect, useState } from "react";
import { api, eur } from "@/lib/api";
import { Clock } from "lucide-react";

function fmt(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("it-IT",
    { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return String(iso).slice(0, 16).replace("T", " "); }
}

export default function CustomerTimeline({ cid }) {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    let stop = false;
    (async () => {
      try {
        const r = await api.get(`/admin/customers/${cid}/timeline`);
        if (!stop) setEvents(r.data || []);
      } catch { if (!stop) setEvents([]); }
    })();
    return () => { stop = true; };
  }, [cid]);

  if (events === null) {
    return <div className="rounded-2xl border border-sand-300 bg-white p-4 text-xs text-ink-500">
      Timeline in caricamento…
    </div>;
  }
  if (events.length === 0) {
    return <div className="rounded-2xl border border-sand-300 bg-white p-4 text-xs text-ink-500 italic">
      Nessun evento nella timeline.
    </div>;
  }

  return (
    <section className="rounded-2xl border border-sand-300 bg-white p-4" data-testid="crm-timeline">
      <h2 className="font-semibold mb-3 flex items-center gap-1">
        <Clock className="w-4 h-4" /> Timeline · {events.length} eventi
      </h2>
      <ol className="relative border-l-2 border-sand-300 ml-2 space-y-3">
        {events.map((e, i) => (
          <li key={i} className="relative pl-4" data-testid={`crm-timeline-${e.type}`}>
            <span className="absolute -left-[13px] top-1 w-6 h-6 flex items-center justify-center rounded-full bg-white border border-sand-300 text-sm">
              {e.icon}
            </span>
            <div className="text-[11px] text-ink-500">{fmt(e.at)}</div>
            <div className="font-medium text-sm">{e.title}</div>
            {e.detail && <div className="text-xs text-ink-500">{e.detail}</div>}
            {e.actor_name && (
              <div className="text-xs text-ink-700" data-testid={`crm-timeline-actor-${i}`}>Operatore: {e.actor_name}</div>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
